import React, { useState, useEffect } from "react";
import "../css/Fenetre_Clusters_Rayon.css";

const Fenetre_Clusters_Rayon = ({ circleClicked,setCircleClicked, rayonDeRecherche, setRayonDeRecherche, afficherClusters, setAfficherClusters, afficherEtatModifications, setAfficherEtatModifications, filteredData }) => {
  const [visible, setVisible] = useState(circleClicked);



  useEffect(() => {
    if (circleClicked) {
      setVisible(true);
    } else {
      setTimeout(() => setVisible(false), 800); 
    }
  }, [circleClicked]);

  


  if (!visible) return null;

  return (
    <div className={`radius-control ${circleClicked ? "fade-in" : "fade-out"}`} style={{ minWidth: "20%" }}>
      <button
        className="close-button"
        onClick={() => setCircleClicked(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "transparent",
          border: "none",
          fontSize: "20px",
          cursor: "pointer",
          color: "black"
        }}
      >
        ×
      </button>
      <label
        style={{
          fontSize: "16px",
          color: "#333",
          fontWeight: "bold",
          marginLeft: "25%",
          marginBottom: "10px",
          width: "100%",
        }}
      >
        Rayon de recherche :
      </label>
      
      <div className="range-container">
        <span style={{ color: "black" }} className="range-min">
          {rayonDeRecherche < 1000 ? "0 km" : "1 km"}
        </span>
        <input
          type="range"
          min={rayonDeRecherche < 1000 ? 0 : rayonDeRecherche === 1000 ? 0 : 1}
          max={rayonDeRecherche < 1000 ? 1 : 50}
          step={rayonDeRecherche <= 1000 ? 0.1 : 1}
          value={rayonDeRecherche / 1000}
          onChange={(e) => setRayonDeRecherche(parseFloat(e.target.value) * 1000)}
          style={{ color: "green" }}
        />
        <span style={{ color: "black" }} className="range-max">
          {rayonDeRecherche < 1000 ? "1 km" : "50 km"}
        </span>
      </div>
      <div style={{ color: "black" }} className="range-value">
        {rayonDeRecherche < 1000 ? `${rayonDeRecherche} m` : `${(rayonDeRecherche / 1000).toFixed(1)} km`}
      </div>
      <div style={{ display: "flex", justifyContent: filteredData.length>0 ? "space-between" : "center", marginTop: "5%" }}>
        <button className="bouton-ajouter-suprrimer-clusters" onClick={() => setAfficherClusters(!afficherClusters)}>
          {afficherClusters ? "Désactiver les clusters" : "Activer les clusters"}
        </button>
        {filteredData.length > 0 && (
        <button className="bouton-ajouter-suprrimer-clusters"  onClick={() => setAfficherEtatModifications(!afficherEtatModifications)}>
          {afficherEtatModifications ? "Désactiver l'état des modifications" : "Activer l'état des modifications"}
        </button>
        )}
      </div>
      
    </div>
  );
};

export default Fenetre_Clusters_Rayon;
